import type { NotificationsLiveKitOptions } from './notifications-live-kit.hook'

import { useToast } from '@shared/lib/toast'

import { useLessonRoomStore } from './store'
import { useNotificationsLiveKit } from './notifications-live-kit.hook'
import { trackClassroomEvent } from '../lib/classroom'
import { trackMediaPermissionError } from '../lib/classroom'

type Unsubscribe = () => void

// A 1:1 lesson: the remote participant is the tutor
const PEER = { name: 'participant', is_self: false, user_role: 'tutor' } as const

interface UseClassroomNotificationsLiveKitReturn {
  listen: () => Unsubscribe
}

export const useClassroomNotificationsLiveKit = (): UseClassroomNotificationsLiveKitReturn => {
  const lessonRoomStore = useLessonRoomStore()
  const toast = useToast()

  const options: NotificationsLiveKitOptions = {
    notify: {
      info: (t) => toast.info(t),
      warning: (t) => toast.warning(t),
      success: (t) => toast.success(t),
      dismiss: (id) => toast.dismiss(id),
    },
    permissions: {
      setDeniedMic: (v) => lessonRoomStore.setDeniedMic(v),
      setDeniedCam: (v) => lessonRoomStore.setDeniedCam(v),
      setBlocked: (v) => lessonRoomStore.setPermissionsBlocked(v),
      isDeniedMic: () => lessonRoomStore.isDeniedMic,
      isDeniedCam: () => lessonRoomStore.isDeniedCam,
    },
    analytics: {
      peerJoined: () => trackClassroomEvent('Room_join', PEER),
      peerLeft: () => trackClassroomEvent('Room_leave', PEER),
      permissionsPopUp: (statuses) => trackMediaPermissionError('media_device_error', statuses),
    },
  }

  return useNotificationsLiveKit(options)
}
